import type { FC } from "react";

import classNames from "classnames";
import isFunction from "lodash/isFunction";

import { CheckboxIcon } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";

import { PlainTooltip } from "../../Tooltip/PlainTooltip/PlainTooltip";
import { SWReactTableWrapperContextConsumer } from "../SWReactTableWrapperSelectionContext";

interface ISelectAllRowsHeaderCellProps {
    allRowsSelected: boolean;
    onSelectAllRows: () => void;
    trackAllSelected?: (allRowsSelected: boolean) => void;
    maxSelectedRows?: number;
    selectedRows?: any[];
    rowsPerPage?: number;
}

export const SelectAllRowsHeaderCell: FC<ISelectAllRowsHeaderCellProps> = ({
    allRowsSelected = false,
    onSelectAllRows,
    maxSelectedRows = undefined,
    selectedRows = [],
    rowsPerPage,
    trackAllSelected,
}) => {
    const className = classNames("row-selection", { "row-selection--selected": allRowsSelected });
    const isDisabled =
        // @ts-ignore FIXME: strict migration - 'rowsPerPage' and 'maxSelectedRows' possibly undefined — preserving legacy NaN comparison behavior
        maxSelectedRows === selectedRows?.length || selectedRows.length + rowsPerPage > maxSelectedRows;
    const onSelectAll = () => {
        if (isFunction(trackAllSelected)) {
            trackAllSelected(!allRowsSelected);
        }
        if (!isDisabled || allRowsSelected) {
            onSelectAllRows?.();
        }
    };
    return (
        <PlainTooltip
            cssClass="plainTooltip-element plainTooltip-element--header"
            placement="top"
            text={i18nFilter()("table.selection.select.all.disable")}
            // @ts-ignore FIXME: Type 'null' is not assignable to type 'boolean | undefined, existing behavior preserved
            enabled={isDisabled ? !allRowsSelected : null}
        >
            <div
                className={className}
                onClick={onSelectAll}
                data-automation-select-all={true}
            >
                <CheckboxIcon
                    selected={allRowsSelected}
                    disabled={isDisabled ? !allRowsSelected : null}
                />
            </div>
        </PlainTooltip>
    );
};

export const SelectAllRowsHeaderCellConsumer = (props: FixmeType) => {
    return (
        <SWReactTableWrapperContextConsumer>
            {({ onSelectAllRows, allRowsSelected, selectedRows = [], maxSelectedRows }) => {
                const SelectAllRowsHeaderCellProps = {
                    ...props,
                    onSelectAllRows,
                    allRowsSelected,
                    selectedRows,
                    maxSelectedRows,
                };
                return <SelectAllRowsHeaderCell {...SelectAllRowsHeaderCellProps} />;
            }}
        </SWReactTableWrapperContextConsumer>
    );
};
